import Model from 'cdna/core/model';
import {calculateDuration} from '../util.js';

export default Model.extend({
    idAttribute: 'Id',
    computed: {
        'durationDescription Duration': calculateDuration
    }
});


/** WEBPACK FOOTER **
 ** ./client/video/video.js
 **/